import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=a7e1f274&scoped=true&"
import script from "./BaseSwitch.vue?vue&type=script&lang=ts&"
export * from "./BaseSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=a7e1f274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e1f274",
  null
  
)

export default component.exports